export interface ProfiloUpdate {
  avatarUrl?: string;
  password?: string;
  emailsGenitori?: Array<string>;
}
